module.exports = __webpack_public_path__ + "img/login_bg.2d7045bf.png";